export const PHONE_MIN = 576;
export const TABLET_MIN = 768;
export const DESKTOP_MIN = 992;
